export class Cuota {
    nrocuota?:string;
    fecha?:string;
    total?:number;
}
